<template>
<div>
<!-- Begin Brevo Signup Form -->
<hr/>
<h3>Join our Mailing List</h3>
<div id="brevo_embed_signup">
    <form action="https://d103494b.sibforms.com/serve/MUIFAA7YYxLA8vgIM2wtREvmJsijMQfES247ATNTzwDaDJ2B6ceKfz2kDaAhpvxniSfA2Q-Y2U8eflvx0JF52PRtTQCNbNwduVvv0VHnXFXe6Zycr3HoS4goo8-P_S0r1lPMgqVlboMxoN8HMmeWzAks93thxuv9dwzI4phmgovmNzA368GyXyNNy0NDiYVzKJqv8DKXAXgJQnwwHA==" method="POST">
        <div id="brevo_embed_signup_scroll">
            <label for="EMAIL" style="font-weight: normal">Sign up to receive occasional news about Handweaving.net.</label><br />
            <input style="margin-bottom: 0.5rem" type="email" value="" name="EMAIL" class="email form-control form-control-inline" id="EMAIL" placeholder="email address" required>
            <!-- Brevo bot protection - do not remove -->
            <input type="text" name="email_address_check" value="" class="input--hidden" style="position:absolute; left:-5000px;" tabindex="-1">
            <input type="hidden" name="locale" value="en">
            <input type="hidden" name="html_type" value="simple">
            &nbsp;
            <input type="submit" value="Sign Up Now" class="button btn btn-primary" style="display: inline">
            <br />
        </div>
    </form>
</div>
</div>
</template>

<script>
</script>

<style scoped>
.form-control-inline {
    min-width: 0;
    width: auto;
    display: inline;
}
</style>
